import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useSelector } from "react-redux"
import NewProductType from "./newproducttype"

export default function ProductTypeDetails({ id }) {

    let producttypes = useSelector(state => state.producttype.producttypes)

    const [producttype, setProducttype] = useState()

    useEffect(() => {

        if (producttypes) {
            let producttype = false
            Object.keys(producttypes).forEach(key => {

                if (producttypes[key].id == id) {
                    producttype = producttypes[key]

                }

            })

            setProducttype(producttype)

        }

    }, [producttypes])

   
    if(!producttype){
        return <Skeleton count={50} />
    }

    return <Fragment>
        {producttype && <NewProductType producttype={producttype} />}
    </Fragment>
}